import './i18n'
import React from 'react'
import ReactDOM from 'react-dom'
import 'css/index.scss'
import 'css/chrome.scss'
import config from 'config'
import App from 'views/App'
import {launchChromeExtension} from 'views/Chrome'
import ChromePopupApp from 'views/Chrome/PopupApp'
import * as serviceWorker from './serviceWorker'

if (config.isChromeExtension) {
  launchChromeExtension()
} else {
  ReactDOM.render(<App />, document.getElementById('__itx-app'))

  // test purposes
  if (config.shouldTestChromeApp) {
    const root = document.createElement('div')
    root.id = '__itx-popup-app-stub'
    // @ts-ignore
    root.style = 'position: absolute; right: 12px; top: 12px; width: 400px; height: 400px;'
    document.body.append(root)
    ReactDOM.render(<ChromePopupApp />, root)
  }

  serviceWorker.unregister()
}
